module.exports = __webpack_public_path__ + "media/images/squiggle__bg-55c415559afd0de40f6900618d485ba3.png";